import { t } from 'i18next';
import { IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import * as Styled from './styled';

export const PopperHeader = ({
  setImportPopperOpened,
}: {
  setImportPopperOpened: (status: boolean) => void;
}) => (
  <Styled.Header>
    <Typography variant="subtitle2">{t('ExportData')}</Typography>

    <IconButton onClick={() => setImportPopperOpened(false)} size="small">
      <CloseIcon />
    </IconButton>
  </Styled.Header>
);
